// extracted by mini-css-extract-plugin
export default {"specifications":"CloudAdd-specifications_xM4Hu"};